














import Vue from 'vue'
import { IDevice } from '@/types/model'
import easyapi from '@/easyapi'

export default Vue.extend({
  data (): {
    spinning: boolean
  } {
    return {
      spinning: false
    }
  },
  computed: {
    show (): boolean { return this.$s.$state.common.networkError }
  },
  methods: {
  }
})
